import { render, staticRenderFns } from "./IncidentCategoryView.vue?vue&type=template&id=0a4fe151&"
import script from "./IncidentCategoryView.vue?vue&type=script&lang=js&"
export * from "./IncidentCategoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports